const Cookies = require('cookies-js')

Cookies.defaults = {
  path: '/',
}

const upercase = string => string.charAt(0).toUpperCase() + string.slice(1)

export const empty = string => string.lenght === 0 ? '' : string
export const userName = name => empty(name).toLowerCase().trim()

export const User = ({ storage = Cookies } = { }) => {
  return {
    set(name) {
      // console.log(name, storage)
      storage.set('naming_username', userName(name), { expires: Infinity })
    },
    get() {
      return userName(storage.get('naming_username'))
    },
    getFormated() {
      return upercase(userName(storage.get('naming_username')))
    },
    loggedIn() {
      if (storage.get('naming_username')) {
        return true
      }
      return false
    },
  }
}


const add = (a, b) => a + b

const sumOfArray = array => array.reduce(add, 0)

export const ratingAverage = rating => {
  if (!rating) {
    return 0
  }
  return sumOfArray(Object.values(rating)) / Object.values(rating).length
}

export const ratingOn100Scale = (rating) => {
  const scale = 100
  const maxCurrent = 5
  return rating * scale / maxCurrent
}


export const formatTimeStamp = (dateTime) => {
// Create a date object with the current time
  if (!dateTime) {
    return ''
  }
  var now = new Date(dateTime);

// Create an array with the current month, day and time
  var date = [ now.getDate(), now.getMonth() + 1, now.getFullYear() ];

// Create an array with the current hour, minute and second
  var time = [ now.getHours(), now.getMinutes() ];

// // Determine AM or PM suffix based on the hour
//   var suffix = ( time[0] < 12 ) ? "AM" : "PM";
//
// // Convert hour from military time
//   time[0] = ( time[0] < 12 ) ? time[0] : time[0] - 12;
//
// // If hour is 0, set it to 12
//   time[0] = time[0] || 12;
//
// If seconds and minutes are less than 10, add a zero
  for ( var i = 1; i < 3; i++ ) {
    if ( time[i] < 10 ) {
      time[i] = "0" + time[i];
    }
  }

// Return the formatted string
  return date.join(".") + " - " + time.join(":");
}



// WEBPACK FOOTER //
// ./src/helper/helper.js